class Col {

  constructor(col, {
    width = 130,
  } = {}) {
    this.col = col;
    this.width = width;
  }

}

export {
  Col,
};
